<div
    class="cmps-cdk-border-radius-4px cmps-cdk-bg-color-white cmps-uik-box-shadow-200 cmps-cdk-p-1 cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-rg-1"
>
    <ng-container *ngIf="_state.viewParams.reportType === _ReportType.Role">
        <div>
            <div>Site</div>
            <cmps-population-select
                [canSelectSite]="true"
                [canSelectAllSites]="true"
                [selectedPopulation]="_Population.Site"
                [singlePopulationSelect]="true"
                [selectableSiteIds]="_state.selectableSiteIds"
                [selection]="_state.viewParams.site"
                (selectionChange)="
                    _state.viewParams.site = $event; _onChange(true)
                "
                (selectionLabelChange)="_onSiteLabelChange($event)"
            ></cmps-population-select>
        </div>

        <div>
            <cmps-radio-group
                [ngModel]="_state.viewParams.dataDimension"
                (ngModelChange)="
                    _state.viewParams.dataDimension = $event; _onChange()
                "
            >
                <div class="cmps-cdk-d-flex cmps-cdk-cg-0dot5">
                    <cmps-radio [value]="_DataDimension.SuperGroup"
                        >SuperGroup</cmps-radio
                    >
                    <cmps-radio [value]="_DataDimension.Queue"
                        >Queue</cmps-radio
                    >
                </div>
            </cmps-radio-group>

            <cmps-population-select
                [canSelectQueue]="true"
                [canSelectAllQueues]="true"
                [selectedPopulation]="_Population.Queue"
                [singlePopulationSelect]="true"
                [selectableQueueIds]="_state.selectableQueueIds"
                [selection]="_state.viewParams.queue"
                (selectionChange)="
                    _state.viewParams.queue = $event; _onChange()
                "
                (selectionLabelChange)="_onQueueLabelChange($event)"
                *ngIf="_state.viewParams.dataDimension === _DataDimension.Queue"
            ></cmps-population-select>

            <cmps-population-select
                [canSelectSuperGroup]="true"
                [selectedPopulation]="_Population.SuperGroup"
                [singlePopulationSelect]="true"
                [selectableSuperGroupIds]="_state.selectableSuperGroupIds"
                [selection]="_state.viewParams.superGroup"
                (selectionChange)="
                    _state.viewParams.superGroup = $event; _onChange()
                "
                (selectionLabelChange)="_onSuperGroupLabelChange($event)"
                *ngIf="
                    _state.viewParams.dataDimension ===
                    _DataDimension.SuperGroup
                "
            ></cmps-population-select>
        </div>
    </ng-container>

    <ng-container *ngIf="_state.viewParams.reportType !== _ReportType.Role">
        <div>
            <div>Queue</div>
            <cmps-population-select
                [canSelectQueue]="true"
                [canSelectAllQueues]="true"
                [selectedPopulation]="_Population.Queue"
                [singlePopulationSelect]="true"
                [selectableQueueIds]="_state.selectableQueueIds"
                [selection]="_state.viewParams.queue"
                (selectionChange)="
                    _state.viewParams.queue = $event; _onChange()
                "
                (selectionLabelChange)="_onQueueLabelChange($event)"
            ></cmps-population-select>
        </div>
    </ng-container>
</div>
